<template>
  <div id="client">
    <div class="container">
      <div class="section">
        <h1>New Project</h1>
        <input v-model="contact" type="text" placeholder="Name" />
        <input v-model="company" type="text" placeholder="Company" />
        <input v-model="email" type="email" placeholder="Email" />
        <input v-model="phoneNumber" type="tel" placeholder="Phone Number" />
      </div>
      <div class="section">
        <h2>Address</h2>
        <input v-model="address" type="text" placeholder="Address" />
        <input v-model="city" type="text" placeholder="City" />
        <input v-model="state" type="text" placeholder="State" />
        <input v-model="zip" type="text" placeholder="Zipcode" />
        <input v-model="country" type="text" placeholder="Country" />
      </div>
      <div class="section row">
        <button id="cancel" @click="$router.replace('/dashboard')">Cancel</button>
        <button @click="saveClient">Save Client</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "../main";
export default {
  name: "NewProject",
  data() {
    return {
      company: "",
      contact: "",
      phoneNumber: "",
      email: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
    };
  },
  methods: {
    saveClient: function () {
      let address_1 = this.address;
      let address_2 = `${this.city}, ${this.state} ${this.zip}`;
      let date = new Date();
      let currDate = date.toLocaleDateString();

      db.collection("clients")
        .add({
          company: this.company,
          contact: this.contact,
          phoneNumber: this.phoneNumber,
          email: this.email,
          address_1: address_1,
          address_2: address_2,
          country: this.country,
          user_id: firebase.auth().currentUser.uid,
          total_due: "$0.00",
          created: currDate,
        })
        .then(() => {
          this.$router.push("/dashboard");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#client {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100vh;
  padding: 35px 0;
  color: #2b303a;
  background: #f7f9fb;

  .row {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center;
    text-align: left;
    width: 350px;

    button {
      border: solid 2px rgb(182, 182, 182);
      border-radius: 3px;
      padding: 10px;
      font-size: 1.2rem;
      width: 60%;
      transition: 0.2s;

      &:hover {
        background: #0cce6b;
        border-color: #2b303a;
      }
    }

    #cancel {
      width: 30%;
      color: rgb(221, 57, 57);
      border-color: rgb(221, 57, 57);

      &:hover {
        background: rgb(221, 57, 57);
        color: #f7f9fb;
      }
    }
  }

  .section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
    width: 350px;

    input {
      border: solid 2px rgb(182, 182, 182);
      border-radius: 3px;
      font-size: 1.2rem;
      margin: 15px 0;
      width: 100%;
      padding: 10px 0;
      text-indent: 10px;

      &:hover {
        border-color: #2b303a;
      }
    }

    h1,
    h2 {
      font-weight: 300;
      width: 100%;
      margin-bottom: 0;
    }
  }
}
</style>